import React from 'react';
import { useLocation } from 'react-router-dom';
import { Receipt, WifiOff } from 'lucide-react';
import useOnlineStatus from '../../hooks/useOnlineStatus';

const TITLES = {
  '/dashboard': 'Dashboard',
  '/expenses': 'Expenses',
  '/trips': 'Trips',
  '/clients': 'Clients & facilities',
  '/settings': 'Settings',
};

/** Compact top bar for the mobile shell's tab pages. */
function MobileTopBar() {
  const { pathname } = useLocation();
  const online = useOnlineStatus();
  const title = TITLES[pathname] || 'Expense Tracker';

  return (
    <header className="md:hidden sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-gray-200 pt-safe">
      <div className="flex items-center gap-2 px-4 h-12">
        <Receipt className="w-6 h-6 text-blue-600 flex-shrink-0" />
        <h1 className="flex-1 text-lg font-semibold text-gray-900 truncate">{title}</h1>
        {!online && (
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-amber-100 text-amber-800 text-xs font-medium">
            <WifiOff className="w-3.5 h-3.5" />
            Offline
          </span>
        )}
      </div>
    </header>
  );
}

export default MobileTopBar;
